module.exports = __webpack_public_path__ + "img/market3.a9cca104.png";